import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { formSchema } from "./constants";
import { formValidator } from "../../../../_helpers/validators";
import { convertDate } from "../../../../_helpers/dateFormatter";
import {
  create_interview_kit_action,
  delete_interview_kit_by_id_data_action,
  get_interview_kit_by_id_data_action,
  set_new_interview_kit_mentor_action,
   update_interview_kit_action
} from "../../../../redux/_actions";

function useNewCreateAssessment(props) {
  const [formData, setFormData] = useState({ ...formSchema });
  const [formInputsError, setFormInputsError] = useState({});
  const [saveLoading, setSaveLoading] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [continueLoading, setContinueLoading] = useState(false);
  const [welcomeNoteEditor, setWelcomeNoteEditor] = useState(false);
  const [outroNoteEditor, setOutroNoteEditor] = useState(false);
  const [loading, setLoading] = useState(false);
  const [previewJob, setPreviewJob] = useState(false);
  const [dueDate, setDueDate] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { interviewKitData, interviewCreated } = useSelector(
    (state) => state.get_interview_kit_by_id_data_reducer
  );

  useEffect(() => {
    resetState();
  }, []);

  useEffect(() => {
    window.scroll(0, 0);
    let id = params?.id;
    if (id) callApi(id);
  }, []);

  useEffect(() => {
    let id = params?.id;
    if (id)
      if (interviewKitData?.data) {
        setFormData(interviewKitData?.data);
        setDueDate(interviewKitData.data?.due_date);
      }
  }, [interviewKitData]);

  useEffect(() => {
    if (interviewKitData?.data) {
      if (previewJob) {
        navigate(`/preview-interview-kit/${interviewKitData.data?.id}`, {
          state: interviewKitData.data?.id,
        });
      }
    }
  }, [interviewKitData, previewJob]);

  const callApi = async (id) => {
    setLoading(true);
    await dispatch(get_interview_kit_by_id_data_action(id));
    setLoading(false);
  };

  const resetState = async () => {
    await dispatch(set_new_interview_kit_mentor_action());
  };

  const onTitleChange = async (e) => {
    setFormInputsError({});
    let value = e.target.value;
    if (value.length > 0) {
      if (formData?.id) {
        let data = formData;
        data["title"] = value;
        setFormData(data);
      } else {
        await dispatch(create_interview_kit_action({ title: value }));
      }
    }
  };

  const onInputChange = async (e) => {
    setFormInputsError({});
    let value = e.target.value;
    let name = e.target.name;
    if (name === "due_date") {
      value = convertDate(value);
      setDueDate(value);
      if (formData?.id) {
        await dispatch(
          update_interview_kit_action({ due_date: value }, formData?.id)
        );
      }
    }
    let data = formData;
    data[name] = value;
    setFormData(data);
  };

  const onCancelClick = () => {
    navigate(-1);
  };

  const onSaveClick = async (id, status) => {
    let [validate, error] = formValidator(formData, formSchema);
    if (id === "preview") {
      setPreviewLoading(true);
    } else if (id === "continue") {
      setContinueLoading(true);
    } else if (id === "save") {
      setSaveLoading(true);
    }
    let data = formData;
    data["status"] = data?.status === "publish" ? "publish" : status;
    if (status === "draft") {
      if (data.title.length === 0) {
        let error = {};
        error["title"] = "Field cannot be empty";
        setFormInputsError(error);
      } else {
        if (formData?.id) {
          await dispatch(update_interview_kit_action(data, formData?.id));
        }
      }
    } else if (status === "publish") {
      if (validate) {
        if (formData?.id) {
          await dispatch(update_interview_kit_action(data, formData?.id));
        }
        if (id === "continue") {
          navigate(-1);
        }
      } else setFormInputsError(error);
    }
    if (id === "preview") {
      setPreviewJob(true);
    }
    setContinueLoading(false);
    setSaveLoading(false);
    setPreviewLoading(false);
  };

  const onDeleteClick = async () => {
    setLoading(true);
    await dispatch(delete_interview_kit_by_id_data_action(formData?.id));
    setLoading(false);
    navigate(-1);
  };

  const openEditor = (id) => {
    if (id === "welcome_note") setWelcomeNoteEditor(!welcomeNoteEditor);
    else if ((id = "epilogue_outro_note")) setOutroNoteEditor(!outroNoteEditor);
  };

  const calculateAssessmentEstimatedTime = () => {
    let data = formData;
    let total_time = 0;
    data?.topics &&
      Array.isArray(data?.topics) &&
      data.topics.forEach((element) => {
        element?.questions &&
          element.questions.forEach(
            (item) => (total_time = item?.time_to_answer + total_time)
          );
      });

    return total_time;
  };

  const onCreateNewTopic = (id) => {
    if (id) navigate(`/create-assessment-kit-topic/${formData?.id}/${id}/`);
    else navigate(`/create-assessment-kit-topic/${formData?.id}/`);
  };

  return {
    formData,
    saveLoading,
    outroNoteEditor,
    welcomeNoteEditor,
    formInputsError,
    continueLoading,
    previewLoading,
    dueDate,
    loading,
    onTitleChange,
    onCancelClick,
    onSaveClick,
    onInputChange,
    openEditor,
    onDeleteClick,
    calculateAssessmentEstimatedTime,
    onCreateNewTopic,
  };
}

export default useNewCreateAssessment;
